import { Redirect } from 'expo-router'
import { useState, type ReactNode } from 'react'
import { View } from 'react-native'

import { HozanimatedLoader } from '@/src/elements/HozanimatedLoader/HozanimatedLoader'
import { Icon } from '@/src/elements/media/Icon'
import { Spacer } from '@/src/elements/spacer/Spacer'
import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useTimeout } from '@/src/general/hooks/useTimeout'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

import { useWatchmanDailyIntentionsQuery } from '../../services/useWatchmanDailyIntentionsQuery'
import { WatchmanSearchParams } from '../components/WatchmanSearchParams'

export const WatchmanRewardScreen = ({ searchParams }: TSearchParamsParam): ReactNode => {
  const [isReady, setIsReady] = useState(false)
  const { t } = useTranslate()
  const { routes } = useRoutes()

  const { data: dailyIntentions } = useWatchmanDailyIntentionsQuery()

  useTimeout(() => setIsReady(true), 3000)

  if (dailyIntentions && isReady) return <Redirect href={routes.watchmanIntentions()} />

  return (
    <View testID={TEST_ID.WATCHMAN.REWARD.SCREEN.NAME} className="h-full w-full items-center pb-6 pt-10">
      {searchParams.action && <WatchmanSearchParams searchParams={searchParams} />}
      <View className="mx-auto flex flex-1 flex-col items-center justify-center gap-4 px-6">
        <View className="items-center">
          <Icon
            name={ICON.LANTERN}
            className="h-12 w-12 native:min-h-12 native:min-w-12 text-primary-icon-contrast-lower"
          />
          <Spacer y={4} />
          <Typography bold center colors="primary" contrast="high" size="xl">
            {t('word.congratulations')}
          </Typography>
          <Typography bold center colors="primary" contrast="high" size="xl">
            {t('intention.prayer.watchman.became-watchman')}
          </Typography>
          <Spacer y={10} />
          <HozanimatedLoader />
          <Spacer y={4} />
          <Typography center italic colors="primary">
            {t('intention.prayer.watchman.fetching')}
          </Typography>
        </View>
      </View>
    </View>
  )
}
